export enum ExerciseStatusType {
    Stopped = 0,
    Countdown = 1,
    InProgress = 2,
    Finished = 3,
    Processing = 4,
    Aborted = 5,
    Error = 100
}